import { createContext } from 'react';
import type { BackendStatus } from './backend-status';

export const BackendStatusContext = createContext<{
  status: BackendStatus;
  setStatus: (patch: Partial<BackendStatus>) => void;
} | null>(null);
